import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
import { PRODUCT_BOX_DIMENSIONS } from '../queries';
const EMPTY_CONFIGURATION_OPTION_VALUE_IDS = [];
const useProductBoxDimensions = (id, slug, t0) => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    configurationOptionValueIds: t2,
    skip: t3
  } = t1;
  const configurationOptionValueIds = t2 === undefined ? EMPTY_CONFIGURATION_OPTION_VALUE_IDS : t2;
  const skip = t3 === undefined ? false : t3;
  const {
    variables,
    skip: skipPdpQuery
  } = usePDPApolloQueryVariables(id, slug);
  let t4;
  if ($[2] !== configurationOptionValueIds) {
    t4 = configurationOptionValueIds.length ? {
      configurationOptionValueIds
    } : {};
    $[2] = configurationOptionValueIds;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4 || $[5] !== variables) {
    t5 = {
      ...variables,
      ...t4
    };
    $[4] = t4;
    $[5] = variables;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const queryVariables = t5;
  const t6 = skip || skipPdpQuery;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      noBatch: true
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== queryVariables || $[9] !== t6) {
    t8 = {
      variables: queryVariables,
      skip: t6,
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      context: t7
    };
    $[8] = queryVariables;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const {
    error,
    data,
    previousData
  } = useQuery(PRODUCT_BOX_DIMENSIONS, t8);
  const querySkipped = skip || skipPdpQuery;
  const hasResult = data !== undefined || previousData !== undefined;
  const box_dimensions = data?.product?.box_dimensions ?? previousData?.product?.box_dimensions;
  const t9 = !querySkipped && !error && !hasResult;
  let t10;
  if ($[11] !== box_dimensions || $[12] !== error || $[13] !== t9) {
    t10 = {
      error,
      box_dimensions,
      pending: t9
    };
    $[11] = box_dimensions;
    $[12] = error;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
export default useProductBoxDimensions;